import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {bindActionCreators} from 'redux';
import {withRouter} from "react-router-dom";
import $ from "jquery";

import { encrypt , decrypt } from "../../../../helpers/CryptoJs";
import {fetchUserFriendList} from "../../../../actions/userAction";
import Remainingpromotion from "../../../Promotion/PromotionBody/remainingpromotion";
import pathList from "../../../../helpers/pathList";
import { loader, pageloader} from '../../../../actions/utils';
import {Pageloader} from "../../../Pageloader";
import iconPath from "./../../../../helpers/iconHelper";
import { getlanguagelist } from "../../../../helpers/changelanguage";

class UserFriend extends Component {

  constructor(props) {
    super(props);
    this.state = {
      urlId           : this.props.urlId,
      userfriend_list : [],
      pagination      : 0,
      total_friend    : 0,
      total_page      : 0,
      lastUserId      : 0
    }
    this.fetchUserFriend        = this.fetchUserFriend.bind(this);
    this.generateFriendContent  = this.generateFriendContent.bind(this);
    this.handleScroll           = this.handleScroll.bind(this);
  }
  componentDidMount() {
   // console.log('mount',this.state);
    pageloader(false);
    window.addEventListener('scroll', this.handleScroll, true);
    if(this.props.changeTab.usertabindex == 1){
      this.fetchUserFriend();
    }
    localStorage.setItem('userpage','friend');
  }
  componentWillUnmount() {
    localStorage.setItem('userpage','');
    localStorage.setItem('apicall','0');
  }
  handleScroll(){
    if ($(window).scrollTop() + $(window).height()  ==  $(document).height()) {
      if((this.state.total_page > this.state.pagination) && (localStorage.getItem('userpage') == 'friend') && (localStorage.getItem('apicall') == '0')){
        //console.log('next page');
        this.fetchUserFriend();
      }
    }
  }
  shouldComponentUpdate(nextProps, prevProps, prevState) {
    if (prevProps.urlId !== prevState.urlId) {
        return true;
    } else {
        return false;
    }
  }
  componentDidUpdate(nextProps,prevState) {
    /* if(nextProps.urlId !== prevState.urlId){
      this.setState({
        urlId         : nextProps.urlId,
        pagination    : 0,
        total_friend  : 0,
        total_page    : 0,
      });
      if(nextProps.urlId === this.state.urlId){
        this.fetchUserFriend();
      }
    }  */
  } 
  fetchUserFriend(){
    localStorage.setItem('apicall','1');
    this.props.fetchUserFriendList(this.state);
  }
  UNSAFE_componentWillReceiveProps(nextProps){
    let totalObj = this.state.userfriend_list;
    if(nextProps.listuserfriend.pagination == 0) {
      totalObj = nextProps.listuserfriend.friendlist;
     
    }else {
      let nextRes = nextProps.listuserfriend.friendlist;
      if(nextRes !== this.props.listuserfriend.friendlist){
        Object.keys(nextRes).map((key) => {
          totalObj.push(nextRes[key]);
        });
      }
     
    }
    if(nextProps.listuserfriend.friendlist !== this.props.listuserfriend.friendlist){
      this.setState({
        userfriend_list : totalObj,
        pagination      : nextProps.listuserfriend.pagination + 1,
        total_friend    : nextProps.listuserfriend.totalfriend,
        total_page      : Math.ceil(nextProps.listuserfriend.totalfriend / 50),
        lastUserId      : this.state.urlId
      },function(){
        localStorage.setItem('apicall','0');
      }) 
    }
    if((nextProps.changeTab.usertabindex == 1) && (this.props.changeTab.usertabindex != nextProps.changeTab.usertabindex)){
      this.fetchUserFriend();
    }
    if((decrypt(window.location.href.split('/')[4]) != this.props.urlId)  && (this.props.changeTab.usertabindex == nextProps.changeTab.usertabindex)){
      this.setState({
          urlId : decrypt(window.location.href.split('/')[4]),
          pagination    : 0,
          total_friend  : 0,
          total_page    : 0,
      },function(){
          this.fetchUserFriend();
      });
    } 
    
  }
  generateFriendContent(friendlist){
    let  languagelist = getlanguagelist();
    return Object.keys(friendlist).map((item) => {
      let details = friendlist[item];
      let classname = '';
      if(details.membership == 'GOLD'){
        classname = "pro_pic golden_m";
      }else{
        classname = "pro_pic";
      }
      return (
          <li key={item}>
            <Link to={`/user/${encrypt(details.id)}`} className="frnds_box">
           {/*  <a href="#0" className="frnds_box"> */}
              <div className={classname}>
              {
                (details.image != '') ? 
                <img src = {details.image} /> : 
                <img src={iconPath['DEFAULTUSER']} />
              }
               
              </div>
              <div className="pro_detail">
                <h4>{details.full_name}</h4>
                <p>{details.country_name}</p>
                <ul className="f_list_details">
                  <li><img src="/assets/images/user_group.png"/> {details.total_friends} {languagelist.friends}</li>
                  <li><img src="/assets/images/ffollow.png"/> {details.total_followers} {languagelist.sfollowers}</li>
                  <li><img src="/assets/images/fpost.png"/> {details.total_post}  {languagelist.posts}</li>
                </ul>
              </div>
            {/*   </a> */}
            </Link>
          </li>
        )
      })
  }
  render() {
    
    let userFriendList = this.state.userfriend_list || {};
    let friendBox = this.generateFriendContent(userFriendList);
    return (
      <div className="row">

        <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 post_area">

          <div className="frnds_area">
            
            <ul>
              {friendBox}
              {/* {Object.keys(userFriendList).length} */}
              <Pageloader/> 
            </ul>
          </div>

        </div>

        <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 right_area">
          <Remainingpromotion/>
        </div>

      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
          changeTab          : state.activetab,
          listuserfriend     : state.listuserfriend,
         }
}
const mapDispatchToProps = dispatch => {
  return{
          fetchUserFriendList: bindActionCreators(fetchUserFriendList, dispatch)
        };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserFriend))